function f() {
  if (console && console.warn) {
    for (var n = arguments.length, e = new Array(n), a = 0; a < n; a++)
      e[a] = arguments[a];
    s(e[0]) && (e[0] = `react-i18next:: ${e[0]}`), console.warn(...e);
  }
}
const i = {};
function p() {
  for (var n = arguments.length, e = new Array(n), a = 0; a < n; a++)
    e[a] = arguments[a];
  s(e[0]) && i[e[0]] || (s(e[0]) && (i[e[0]] = /* @__PURE__ */ new Date()), f(...e));
}
const c = (n, e) => () => {
  if (n.isInitialized)
    e();
  else {
    const a = () => {
      setTimeout(() => {
        n.off("initialized", a);
      }, 0), e();
    };
    n.on("initialized", a);
  }
}, m = (n, e, a) => {
  n.loadNamespaces(e, c(n, a));
}, b = (n, e, a, o) => {
  s(a) && (a = [a]), a.forEach((t) => {
    n.options.ns.indexOf(t) < 0 && n.options.ns.push(t);
  }), n.loadLanguages(e, c(n, o));
}, h = function(n, e) {
  let a = arguments.length > 2 && arguments[2] !== void 0 ? arguments[2] : {};
  const o = e.languages[0], t = e.options ? e.options.fallbackLng : !1, r = e.languages[e.languages.length - 1];
  if (o.toLowerCase() === "cimode") return !0;
  const g = (l, d) => {
    const u = e.services.backendConnector.state[`${l}|${d}`];
    return u === -1 || u === 2;
  };
  return a.bindI18n && a.bindI18n.indexOf("languageChanging") > -1 && e.services.backendConnector.backend && e.isLanguageChangingTo && !g(e.isLanguageChangingTo, n) ? !1 : !!(e.hasResourceBundle(o, n) || !e.services.backendConnector.backend || e.options.resources && !e.options.partialBundledLanguages || g(o, n) && (!t || g(r, n)));
}, L = function(n, e) {
  let a = arguments.length > 2 && arguments[2] !== void 0 ? arguments[2] : {};
  return !e.languages || !e.languages.length ? (p("i18n.languages were undefined or empty", e.languages), !0) : e.options.ignoreJSONStructure !== void 0 ? e.hasLoadedNamespace(n, {
    lng: a.lng,
    precheck: (t, r) => {
      if (a.bindI18n && a.bindI18n.indexOf("languageChanging") > -1 && t.services.backendConnector.backend && t.isLanguageChangingTo && !r(t.isLanguageChangingTo, n)) return !1;
    }
  }) : h(n, e, a);
}, s = (n) => typeof n == "string", C = (n) => typeof n == "object" && n !== null;
export {
  L as hasLoadedNamespace,
  C as isObject,
  s as isString,
  b as loadLanguages,
  m as loadNamespaces,
  f as warn,
  p as warnOnce
};
